import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../../../models/appConfig.model';
import { UtilityService } from '../../../services/shared/utility.service';

@Component({
    selector: 'app-missing-credentials',
    templateUrl: './missing-credentials.component.html',
    styleUrls: ['./missing-credentials.component.css']
})
/** missing-credentials component*/
export class MissingCredentialsComponent implements OnInit {

    private _appConfig: AppConfig;

    /** missing-credentials ctor */
    constructor() {

    }

    ngOnInit() {
        this.redirectToMySO();
    }

    onBackClick() {
        //window.location.replace('https://localhost:44320/');
    }

    private async readConfig() {
        this._appConfig = UtilityService.AppConfig;
    }

    private async redirectToMySO() {
        await this.readConfig();

        window.location.href = this._appConfig.portalURL;
    }
}
